import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';

import { getEWUser, getRiskLabels } from '../restapi/warning';
import { riskLabelDef } from '../restapi/types';
import { addMonths, isSimpleDate, type SimpleDate, simplyToday, trimesterStart } from '../utils/SimpleDate';


// read current user
export function useEWUser() {
	const userQuery = useQuery(['user'], () => getEWUser(), {
		staleTime: Infinity, cacheTime: Infinity,  // never reload
	});
	return userQuery.data;
}

export function useRiskLabels() {
	const userQuery = useQuery(['riskLabel'], () => getRiskLabels(), {
		staleTime: Infinity, cacheTime: Infinity,  // never reload
	});
	return userQuery.data || riskLabelDef;
}

export function useCalendarRangeStart(): SimpleDate {
	const {from} = useParams<{ from: string }>();
	return trimesterStart(
		isSimpleDate(from) ? from : addMonths(simplyToday(), -2),
	);
}
